import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const EventsCountDataSlice = createSlice({
    name: "eventsCount",
    initialState,
    reducers: {
        getEventsCountRequest(state) {
            state.loading = true;
        },
        getEventsCountRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getEventsCountRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getEventsCountRequest,
    getEventsCountRequestSuccess,
    getEventsCountRequestError,
} = EventsCountDataSlice.actions;

export default EventsCountDataSlice.reducer;
